<section class="configurable-detail-form">
  <header class="detail-form-header" *ngIf="headerFields.length">
    <div class="detail-form-header__identity">
      <ng-container *ngFor="let field of headerFields">
      <button
        class="detail-form-badge"
        type="button"
        *ngIf="field.type === 'badge' && field.toggleValues?.length"
        [class.on]="text(field.value).toLowerCase() === 'active'"
        [class.draft]="text(field.value).toLowerCase() === 'draft'"
        [class.numeric]="field.variant === 'numeric'"
        [class.date]="field.variant === 'date'"
        [class.version]="field.variant === 'version'"
        (click)="toggleBadge(field)">
        {{ text(field.value) }}
      </button>
      <span
        class="detail-form-badge"
        *ngIf="field.type === 'badge' && !field.toggleValues?.length"
        [class.on]="field.variant === 'success'"
        [class.numeric]="field.variant === 'numeric'"
        [class.date]="field.variant === 'date'"
        [class.version]="field.variant === 'version'">
        {{ text(field.value) }}
      </span>
      <span class="detail-form-text" *ngIf="field.type !== 'badge' && field.type !== 'button'">
        <strong *ngIf="field.label">{{ field.label }}</strong>
        {{ text(field.value) }}
      </span>
      </ng-container>
    </div>
    <div class="detail-form-header__actions">
      <ng-container *ngFor="let field of headerFields">
        <button
          class="detail-form-action"
          type="button"
          *ngIf="field.type === 'button'"
          (click)="field.action && triggerAction(field.action)">
          <mat-icon *ngIf="field.icon">{{ field.icon }}</mat-icon>
          {{ text(field.label || field.value) }}
        </button>
      </ng-container>
    </div>
  </header>

  <section
    class="detail-section"
    *ngFor="let section of sections; let sectionIndex = index"
    [class.detail-section--attributes]="sectionTitle(section).toLowerCase() === 'attributes'"
    [ngStyle]="sectionAccent(section)">
    <button
      class="detail-section__header"
      type="button"
      [attr.aria-expanded]="!isCollapsed(section, sectionIndex)"
      (click)="toggleSection(section, sectionIndex)">
      <div class="detail-section__title">
        <span class="detail-section__icon" *ngIf="section.icon">{{ section.icon }}</span>
        <span class="detail-section__heading">{{ sectionTitle(section) }}</span>
        <span class="detail-section__count" *ngIf="section.count !== undefined">{{ section.count }}</span>
      </div>
      <span class="detail-section__meta">
        <ng-container *ngFor="let field of section.headerFields || []; let headerFieldIndex = index">
          <span
            class="detail-form-badge"
            *ngIf="field.type === 'badge'"
            [class.on]="field.variant === 'success'"
            [class.numeric]="field.variant === 'numeric'"
            [class.date]="field.variant === 'date'"
            [class.version]="field.variant === 'version'">
            {{ text(field.value) }}
          </span>
          <span class="detail-section__header-text" *ngIf="field.type === 'label'">
            {{ text(field.value) }}
          </span>
          <button class="detail-form-action" type="button" *ngIf="field.type === 'button'" (click)="$event.stopPropagation()">
            {{ text(field.label || field.value) }}
          </button>
          <span
            class="toggle"
            *ngIf="field.type === 'toggle'"
            [class.on]="isChecked(field, sectionIndex, 'header', 0, headerFieldIndex)"
            (click)="$event.stopPropagation(); toggleControl(field, sectionIndex, 'header', 0, headerFieldIndex)">
            <input
              type="checkbox"
              [checked]="isChecked(field, sectionIndex, 'header', 0, headerFieldIndex)"
              [disabled]="field.disabled"
              (click)="$event.preventDefault(); $event.stopPropagation()" />
          </span>
        </ng-container>
        <span class="detail-section__subtitle" *ngIf="section.subtitle">{{ text(section.subtitle) }}</span>
        <span class="detail-section__chevron" [class.collapsed]="isCollapsed(section, sectionIndex)">⌃</span>
      </span>
    </button>

    <div class="detail-section__body" *ngIf="!isCollapsed(section, sectionIndex)">
      <ng-container *ngIf="section.variant === 'child-entities'">
        <p class="detail-child-entities__empty" *ngIf="section.emptyText && !childEntities().length">{{ section.emptyText }}</p>
        <div class="detail-child-entities__chips" *ngIf="childEntities().length">
          <span *ngFor="let entity of childEntities()">
            {{ entity }} <button type="button" (click)="removeChild(section, entity)">×</button>
          </span>
        </div>
        <div class="detail-child-entities__link">
          <input type="text" placeholder="child entity name" [value]="childInputValue(sectionIndex)" (input)="setChildValue(sectionIndex, $event)" />
          <button class="detail-form-action" type="button" (click)="linkChild(section, sectionIndex)">+ Link Child</button>
        </div>
      </ng-container>

      <ng-container *ngIf="section.variant === 'business-rules'">
        <div class="business-rules__toggles">
          <label *ngFor="let field of section.fields || []; let fieldIndex = index">
            <span class="toggle" [class.on]="isChecked(field, sectionIndex, 'fields', 0, fieldIndex)" (click)="toggleControl(field, sectionIndex, 'fields', 0, fieldIndex)">
              <input type="checkbox" [checked]="isChecked(field, sectionIndex, 'fields', 0, fieldIndex)" (click)="$event.preventDefault(); $event.stopPropagation()" />
            </span>
            {{ field.label }}
          </label>
        </div>

        <div class="business-rules__heading"><strong>INTRA-ENTITY RULES</strong><span>{{ ruleRows(section).length }}</span></div>
        <div class="business-rules__table">
          <div class="business-rules__header"><span>ATTRIBUTE</span><span>OPERATOR</span><span>VALUE</span><span>LOGIC</span><span></span></div>
          <div class="business-rules__row" *ngFor="let row of ruleRows(section)">
            <ng-container *ngFor="let field of row.fields || []">
              <input *ngIf="field.type === 'text'" [value]="field.value" />
              <select *ngIf="field.type === 'select'" [value]="field.value"><option *ngFor="let option of field.options" [value]="option.value">{{ option.label }}</option></select>
            </ng-container>
            <button type="button" class="business-rules__remove" (click)="removeBusinessRule(section, row)">×</button>
          </div>
        </div>

        <div class="business-rules__add-row">
          <ng-container *ngFor="let field of ruleInputRow(section).fields || []; let fieldIndex = index">
            <input *ngIf="field.type === 'text'" [placeholder]="field.placeholder || ''" [value]="rowFieldValue(sectionIndex, (section.rows?.length || 1) - 1, fieldIndex, field)" (input)="setRowFieldValue(sectionIndex, (section.rows?.length || 1) - 1, fieldIndex, $event)" />
            <select *ngIf="field.type === 'select'" [value]="rowFieldValue(sectionIndex, (section.rows?.length || 1) - 1, fieldIndex, field)" (change)="setRowFieldValue(sectionIndex, (section.rows?.length || 1) - 1, fieldIndex, $event)"><option *ngFor="let option of field.options" [value]="option.value">{{ option.label }}</option></select>
            <button *ngIf="field.type === 'button'" class="detail-form-action" type="button" (click)="addInlineRow(section, sectionIndex, ruleInputRow(section), (section.rows?.length || 1) - 1)">{{ field.label }}</button>
          </ng-container>
        </div>

        <div class="business-rules__heading"><strong>INTER-ENTITY RULES</strong><span>{{ interEntities().length }}</span></div>
        <div class="business-rules__entities" *ngIf="interEntities().length">
          <div *ngFor="let entity of interEntities()"><span>{{ entity }}</span><button type="button" (click)="removeInterEntity(section, entity)">×</button></div>
        </div>
        <div class="business-rules__add-entity">
          <input placeholder="entity name" [value]="interEntityInput(sectionIndex)" (input)="setInterEntityInput(sectionIndex, $event)" />
          <button class="detail-form-action" type="button" (click)="addInterEntity(section, sectionIndex)">+ Add Entity</button>
        </div>
      </ng-container>

      <ng-container *ngIf="section.variant === 'deam-reads'">
        <div class="deam-reads__list" *ngIf="deamReads().length">
          <article class="deam-read" *ngFor="let filter of deamReads()">
            <header>
              <span class="deam-read__type">{{ filter.type }}</span>
              <strong>{{ filter.name }}</strong>
              <select [value]="filter.type" (change)="setDeamReadType(filter, $event)">
                <option value="static">static</option><option value="dynamic">dynamic</option>
              </select>
              <button type="button" class="deam-read__expand" (click)="filter.expanded = !filter.expanded">{{ filter.expanded ? '⌃' : '⌄' }}</button>
              <button type="button" class="deam-read__remove" (click)="removeDeamRead(section, filter)">×</button>
            </header>
            <label *ngIf="filter.expanded">
              <span>SQL QUERY</span>
              <textarea
                rows="4"
                placeholder="SELECT * FROM purchase_order WHERE is_active = true"
                [value]="filter.sql"
                (input)="setDeamReadSql(filter, $event)"></textarea>
            </label>
          </article>
        </div>
        <div class="deam-reads__add">
          <input placeholder="filterName *" [value]="deamReadInput().name" (input)="setDeamReadInput('name', $event)" />
          <select [value]="deamReadInput().type" (change)="setDeamReadInput('type', $event)"><option value="static">static</option><option value="dynamic">dynamic</option></select>
          <button class="detail-form-action" type="button" [disabled]="!deamReadInput().name.trim()" (click)="addDeamRead(section)">+ Add Filter</button>
        </div>
      </ng-container>

      <div class="detail-field-grid" *ngIf="section.fields?.length && section.variant !== 'business-rules'">
        <ng-container *ngFor="let field of section.fields || []; let fieldIndex = index">
          <label
            *ngIf="fieldVisible(field)"
            class="detail-field"
            [class.detail-field--toggle]="field.type === 'toggle'"
            [class.detail-field--version]="field.layout === 'version'"
            [ngStyle]="fieldStyle(field)">
            <span *ngIf="field.label">{{ field.label }}</span>

            <input
              *ngIf="field.type === 'text'"
              [placeholder]="field.placeholder || ''"
              [value]="text(field.value)"
              (input)="setFieldValue(field, $event)"
              [disabled]="field.disabled" />

            <input
              *ngIf="field.type === 'number'"
              type="number"
              [value]="field.value"
              [min]="field.min ?? null"
              [max]="field.max ?? null"
              [step]="field.step ?? 1"
              (input)="setFieldValue(field, $event)"
              [disabled]="field.disabled" />

            <select *ngIf="field.type === 'select'" [disabled]="field.disabled" (change)="setFieldValue(field, $event)">
              <option *ngFor="let option of field.options" [value]="option.value" [selected]="option.value === field.value">
                {{ option.label }}
              </option>
            </select>

              <span
                class="toggle"
                *ngIf="field.type === 'toggle'"
                [class.on]="isChecked(field, sectionIndex, 'fields', 0, fieldIndex)"
                (click)="$event.stopPropagation(); toggleControl(field, sectionIndex, 'fields', 0, fieldIndex)">
                <input
                  type="checkbox"
                  [checked]="isChecked(field, sectionIndex, 'fields', 0, fieldIndex)"
                  [disabled]="field.disabled"
                  (click)="$event.preventDefault(); $event.stopPropagation()" />
              </span>

            <input
              *ngIf="field.type === 'checkbox'"
              type="checkbox"
              [checked]="isChecked(field, sectionIndex, 'fields', 0, fieldIndex)"
              [disabled]="field.disabled"
              (change)="toggleControl(field, sectionIndex, 'fields', 0, fieldIndex)" />

            <input
              *ngIf="field.type === 'radio'"
              type="radio"
              [checked]="isChecked(field, sectionIndex, 'fields', 0, fieldIndex)"
              [disabled]="field.disabled"
              (click)="toggleControl(field, sectionIndex, 'fields', 0, fieldIndex)" />

            <span class="detail-field__value" *ngIf="field.type === 'label'">{{ text(field.value) }}</span>
          </label>
        </ng-container>
      </div>

      <label class="detail-section__search" *ngIf="section.search?.placeholder">
        <span>⌕</span>
        <input type="search" [placeholder]="section.search?.placeholder || ''" />
      </label>

      <div
        class="detail-table-header"
        [class.detail-table-header--draggable]="section.draggableRows"
        [class.detail-table-header--expandable]="sectionHasExpandableRows(section)"
        *ngIf="section.columns?.length">
        <span *ngIf="section.draggableRows"></span>
        <span *ngFor="let column of section.columns">{{ column.label }}</span>
        <span *ngIf="sectionHasExpandableRows(section)"></span>
        <span *ngIf="sectionHasExpandableRows(section)"></span>
      </div>

      <div class="detail-row-list" *ngIf="section.rows?.length && section.variant !== 'child-entities' && section.variant !== 'business-rules' && section.variant !== 'deam-reads'">
        <div
          class="detail-row-shell"
          *ngFor="let row of section.rows; let rowIndex = index"
          [class.detail-row-shell--expanded]="isRowExpanded(row, sectionIndex, rowIndex)"
          [draggable]="isRowDraggable(section, row)"
          (dragstart)="onDragStart(sectionIndex, rowIndex, $event)"
          (dragover)="onDragOver($event)"
          (drop)="onDrop(section, sectionIndex, rowIndex, $event)">
          <div
            class="detail-row"
            [class.detail-row--draggable]="isRowDraggable(section, row)"
            [class.detail-row--expandable]="isRowExpandable(section, row)">
            <span class="detail-row__drag" *ngIf="isRowDraggable(section, row)" aria-hidden="true">⋮⋮</span>
            <ng-container *ngFor="let field of row.fields || []; let fieldIndex = index">
              <span class="detail-chip" *ngIf="field.type === 'badge'" [class.numeric]="field.variant === 'numeric'" [class.date]="field.variant === 'date'" [class.version]="field.variant === 'version'">
                {{ text(field.value) }}
              </span>
              <span class="detail-row__text" *ngIf="field.type === 'label'">{{ text(field.value) }}</span>
              <input *ngIf="field.type === 'text'" [placeholder]="field.placeholder || ''" [value]="rowFieldValue(sectionIndex, rowIndex, fieldIndex, field)" (input)="setRowFieldValue(sectionIndex, rowIndex, fieldIndex, $event)" />
              <select *ngIf="field.type === 'select'" [value]="rowFieldValue(sectionIndex, rowIndex, fieldIndex, field)" (change)="setRowFieldValue(sectionIndex, rowIndex, fieldIndex, $event)">
                <option *ngFor="let option of field.options" [value]="option.value" [selected]="option.value === field.value">
                  {{ option.label }}
                </option>
              </select>
              <input
                *ngIf="field.type === 'checkbox'"
                type="checkbox"
                [checked]="isChecked(field, sectionIndex, 'rows', rowIndex, fieldIndex)"
                [disabled]="field.disabled"
                (change)="toggleControl(field, sectionIndex, 'rows', rowIndex, fieldIndex)" />
              <input
                *ngIf="field.type === 'radio'"
                type="radio"
                [checked]="isChecked(field, sectionIndex, 'rows', rowIndex, fieldIndex)"
                [disabled]="field.disabled"
                (click)="toggleControl(field, sectionIndex, 'rows', rowIndex, fieldIndex)" />
              <span
                class="toggle"
                *ngIf="field.type === 'toggle'"
                [class.on]="isChecked(field, sectionIndex, 'rows', rowIndex, fieldIndex)"
                (click)="$event.stopPropagation(); toggleControl(field, sectionIndex, 'rows', rowIndex, fieldIndex)">
                <input
                  type="checkbox"
                  [checked]="isChecked(field, sectionIndex, 'rows', rowIndex, fieldIndex)"
                  [disabled]="field.disabled"
                  (click)="$event.preventDefault(); $event.stopPropagation()" />
              </span>
              <button class="detail-form-action" type="button" *ngIf="field.type === 'button'" (click)="addInlineRow(section, sectionIndex, row, rowIndex)">
                {{ text(field.label || field.value) }}
              </button>
            </ng-container>
            <button
              class="detail-row__expand"
              type="button"
              *ngIf="isRowExpandable(section, row) || row.removable"
              [attr.aria-expanded]="isRowExpanded(row, sectionIndex, rowIndex)"
              (click)="toggleRow(section, row, sectionIndex, rowIndex)">
              {{ isRowExpanded(row, sectionIndex, rowIndex) ? '⌃' : '⌄' }}
            </button>
            <button
              class="detail-row__remove"
              type="button"
              *ngIf="isRowExpandable(section, row)"
              (click)="$event.stopPropagation(); removeRow(section, rowIndex)">×</button>
          </div>

          <div class="detail-row-expanded" *ngIf="isRowExpanded(row, sectionIndex, rowIndex)">
            <div class="detail-row-expanded__grid">
              <ng-container *ngFor="let field of rowExpandedFields(section, row); let expandedFieldIndex = index">
                <label
                  class="detail-field"
                  [class.detail-field--toggle]="field.type === 'toggle'"
                  [ngStyle]="fieldStyle(field)">
                  <span *ngIf="field.label">{{ field.label }}</span>

                  <input
                    *ngIf="field.type === 'text'"
                    [placeholder]="field.placeholder || ''"
                    [value]="text(field.value)"
                    [disabled]="field.disabled" />

                  <input
                    *ngIf="field.type === 'number'"
                    type="number"
                    [placeholder]="field.placeholder || ''"
                    [value]="text(field.value)"
                    [disabled]="field.disabled" />

                  <select *ngIf="field.type === 'select'" [disabled]="field.disabled">
                    <option *ngFor="let option of field.options" [value]="option.value" [selected]="option.value === field.value">
                      {{ option.label }}
                    </option>
                  </select>

                  <span
                    class="toggle"
                    *ngIf="field.type === 'toggle'"
                    [class.on]="isChecked(field, sectionIndex, 'expandedRows', rowIndex, expandedFieldIndex)"
                    (click)="$event.stopPropagation(); toggleControl(field, sectionIndex, 'expandedRows', rowIndex, expandedFieldIndex)">
                    <input
                      type="checkbox"
                      [checked]="isChecked(field, sectionIndex, 'expandedRows', rowIndex, expandedFieldIndex)"
                      [disabled]="field.disabled"
                      (click)="$event.preventDefault(); $event.stopPropagation()" />
                  </span>

                  <input
                    *ngIf="field.type === 'checkbox'"
                    type="checkbox"
                    [checked]="isChecked(field, sectionIndex, 'expandedRows', rowIndex, expandedFieldIndex)"
                    [disabled]="field.disabled"
                    (change)="toggleControl(field, sectionIndex, 'expandedRows', rowIndex, expandedFieldIndex)" />

                  <span class="detail-field__value" *ngIf="field.type === 'label'">{{ text(field.value) }}</span>
                </label>
              </ng-container>
            </div>

            <div class="detail-row-expanded__valid-values" *ngIf="rowValidValues(section, row).length">
              <span>Valid Values</span>
              <div>
                <span class="detail-valid-chip" *ngFor="let value of rowValidValues(section, row)">{{ value }} ×</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="detail-add-row" *ngIf="section.addRow?.fields?.length">
        <ng-container *ngFor="let field of section.addRow?.fields || []; let addFieldIndex = index">
          <input
            *ngIf="field.type === 'text'"
            [placeholder]="field.placeholder || ''"
            [value]="addFieldValue(sectionIndex, addFieldIndex, field)"
            (input)="setAddFieldValue(sectionIndex, addFieldIndex, $event)" />
          <select
            *ngIf="field.type === 'select'"
            [value]="addFieldValue(sectionIndex, addFieldIndex, field)"
            (change)="setAddFieldValue(sectionIndex, addFieldIndex, $event)">
            <option *ngFor="let option of field.options" [value]="option.value" [selected]="option.value === field.value">
              {{ option.label }}
            </option>
          </select>
          <button
            class="detail-form-action detail-form-action--primary"
            type="button"
            *ngIf="field.type === 'button'"
            (click)="addRow(section, sectionIndex)">
            {{ text(field.label || field.value) }}
          </button>
        </ng-container>
      </div>

      <div class="detail-actions" *ngIf="section.actions?.length">
        <ng-container *ngFor="let action of section.actions || []">
          <button class="detail-form-action" type="button" *ngIf="action.type === 'button'">
            {{ text(action.label || action.value) }}
          </button>
        </ng-container>
      </div>
    </div>
  </section>
</section>
